import { createQueryApi } from '@/shared/features/query/infra/adapters/rtk.adapter';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';
import type { VideoCallCartResponseDTO } from '../dto/videoCall.dto';
import type { VideoCallCartState } from '../../domain/models/VideoCallCart';
import type { VideoCallRepository } from '../../domain/interfaces/VideoCallRepository';
import { adaptVideoCallCartDtoToState } from '../mappers/videoCall.mapper';
import type { AppDispatch } from '@/app/store/store';

const _videoCallApi = createQueryApi({ clientId: 'videoCallApi' });

const videoCallRtkApi = _videoCallApi.injectEndpoints({
  endpoints: (builder) => ({
    addToVideoCallCart: builder.mutation<VideoCallCartResponseDTO, number>({
      query: (customizationId) => ({
        url: '/checkout/cart/add-to-tah-cart',
        method: 'POST',
        data: `customizationId=${customizationId}&cartType=videoCallTah`,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        withCredentials: true,
      }),
    }),
  }),
});

export const videoCallApiRedux = _videoCallApi as unknown as ReduxQueryClient;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- RTK Query hooks types are complex
const hooks = videoCallRtkApi as any;
export const useAddToVideoCallCartMutation: () => ReturnType<typeof hooks.useAddToVideoCallCartMutation> =
  () => hooks.useAddToVideoCallCartMutation();

export class VideoCallAdapter implements VideoCallRepository {
  constructor(private readonly dispatch: AppDispatch) {}

  async addToVideoCallCart(customizationId: number): Promise<VideoCallCartState> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- RTK mutation result typing
    const result = await (this.dispatch as any)(
      videoCallRtkApi.endpoints.addToVideoCallCart.initiate(customizationId)
    );
    if ('error' in result) throw result.error;
    return adaptVideoCallCartDtoToState(result.data as VideoCallCartResponseDTO);
  }
}
